import { APIFieldType } from '@ardoq/api-types';

export const CUSTOM_ID_ALLOWED_TYPES = [
  APIFieldType.NUMBER,
  APIFieldType.TEXT,
  APIFieldType.EMAIL,
];
